import PropTypes from 'prop-types'
import React from 'react'
import ReactTable from 'react-table'
import { SAMPLE_PLATE_LETTERS } from '../../../../constants/saxs'
import { getRoundedNumber } from '../DataCollectionHelper'
import groupBy from 'lodash/groupBy'
import keys from 'lodash/keys'
import uniqBy from 'lodash/uniqBy'

/**
 * React component which renders the panel to visualize the plate setup
 */
class SaxsPlateTable extends React.Component {
  constructor(props) {
    super(props)
    this.getColumns = this.getColumns.bind(this)
  }

  render() {
    if (!this.props.dataCollections) {
      return null
    }
    const dataCollections = uniqBy(this.props.dataCollections, 'specimenId')

    dataCollections.map(dataCollection => {
      dataCollection.acronym = dataCollection.macromoleculeId ? dataCollection.macromoleculeAcronym : 'Buffers'
      dataCollection.macromoleculeAcronym = dataCollection.macromoleculeId
        ? dataCollection.macromoleculeAcronym
        : 'Buffers'
    })

    return (
      <ReactTable
        data={dataCollections}
        columns={this.getColumns()}
        pivotBy={['macromoleculeAcronym']}
        expanded={(function () {
          const result = []
          for (let x = 0; x < keys(groupBy(dataCollections, dataCollection => dataCollection.acronym)).length; x++) {
            result.push({ [x]: true })
          }
          return result
        })()}
        pageSize={5}
      />
    )
  }

  getColumns() {
    return [
      {
        Header: 'Macromolecule',
        accessor: 'macromoleculeAcronym',
      },
      {
        Header: 'Buffer',
        accessor: 'bufferId',
        Aggregated: () => null,
        Cell: () => null,
      },
      {
        Header: 'Conc',
        accessor: 'specimenConcentration',
        Aggregated: () => null,
        Cell: row => {
          if (Number.isNaN(row.value)) {
            return <div style={{ backgroundColor: 'yellow' }}> {row.value} </div>
          }

          if (row.value !== 0) {
            return (
              <span>
                {getRoundedNumber(row.value, 2)} <span style={{ fontSize: '10px', color: 'gray' }}>mg/mL</span>
              </span>
            )
          }
          return ''
        },
      },
      {
        Header: 'Vol. Well',
        accessor: 'specimenVolume',
        Aggregated: () => null,
        Cell: row => (
          <span>
            {getRoundedNumber(row.value, 2)} <span style={{ fontSize: '10px', color: 'gray' }}> &#181;L</span>
          </span>
        ),
      },
      {
        Header: 'Plate',
        accessor: 'samplePlate_slotPositionColumn',
        Aggregated: () => null,
        Cell: row => {
          if (row.value !== null && row.value !== '') {
            return row.value
          }
          return <div style={{ backgroundColor: 'yellow' }}> {row.val} </div>
        },
      },
      {
        Header: 'Row',
        accessor: 'samplePlatePosition_rowNumber',
        Aggregated: () => null,
        Cell: row => {
          if (row.value !== null && row.value !== '') {
            return SAMPLE_PLATE_LETTERS[row.value - 1]
          }
          return <div style={{ backgroundColor: 'yellow' }}> {row.value} </div>
        },
      },
      {
        Header: 'Well',
        accessor: 'samplePlatePosition_columnNumber',
        Aggregated: () => null,
        Cell: row => {
          if (row.value !== null && row.value !== '') {
            return row.value
          }
          return <div style={{ backgroundColor: 'yellow' }}> {row.value} </div>
        },
      },
    ]
  }
}

export default SaxsPlateTable

SaxsPlateTable.propTypes = {
  /** datacollection list */
  dataCollections: PropTypes.array,
}
